export const PATHS = {
    HOME: '/',
    HOME_HEAD: '/#main',
    HOME_UPLOAD: '/#upload',
    HOME_HOW_IT_WORK: '/#section-how-it-work',
    HOME_FAQS: '/#section-faqs',
    UPLOAD: '/upload',
    TERMS_OF_USE: '/terms-of-use',
    PRIVACY_POLICY: '/privacy-policy',
    ABOUT: '/about',
    CONTACT: '/contact',
    DOWNLOAD: '/download/:id',
    CHECK: '/check',
    REPORT: '/report',
    COUPON: '/coupon',
    VOIP_CHECKER: '/voip-checker',
    HOW_TO_VERIFY_PHONE: '/how-to-verify-a-phone-number',
    BULK_PHONE_VALIDATION: '/bulk-phone-number-validation',
    CARRIER_LOOKUP: '/carrier-lookup',
    FREE_PHONE_LOOKUP: '/free-phone-number-lookup',
    HOW_TO_CLEAN_SMS_LIST: '/how-to-clean-a-phone-list-for-sms',
    CHECK_MOBILE_OR_LANDLINE: '/check-mobile-or-landline',
    WHAT_IS_VOIP_NUMBER: '/what-is-a-voip-number',
    CAN_YOU_TEXT_LANDLINE: '/can-you-text-a-landline',
    IS_THIS_A_REAL_PHONE: '/is-this-a-real-phone-number',
    WHAT_IS_LANDLINE: '/what-is-a-landline',
    RESOURCES: '/resources',
    PRICING: '/pricing',
    GLOSSARY: '/glossary',
    GLOSSARY_TERM: '/glossary/:slug',
    ALTERNATIVES: '/phonecheckr-alternatives',
    PHONE_VALIDATION_API: '/phone-number-validation-api',
    US_AREA_CODES: '/us-area-codes',
    REAL_ESTATE: '/phone-validation-for-real-estate',
    ECOMMERCE: '/phone-validation-for-ecommerce',
    PHONE_SCRUBBER: '/phone-number-scrubber',
    PHONE_ENRICHMENT: '/phone-number-enrichment',
    INSURANCE: '/phone-validation-for-insurance',
    RECRUITING: '/phone-validation-for-recruiting',
    HEALTHCARE: '/phone-validation-for-healthcare',
    DEBT_COLLECTION: '/phone-validation-for-debt-collection',
    PHONE_VERIFICATION_TOOL: '/phone-number-verification-tool',
    FREE_PHONE_VALIDATION: '/free-phone-number-validation',
    FREE_PHONE_CHECKER: '/free-phone-number-checker',
    CHANGELOG: '/changelog',
    // Localhost-only design preview surfaces. Registered in App.tsx under
    // an `isLocalhost` guard so they never render on staging or prod, and
    // 404 cleanly via functions/[[path]].js if anyone probes them.
    DESIGN: '/design',
    DESIGN_V1: '/design/v1',
    DESIGN_V2: '/design/v2',
    DESIGN_V3: '/design/v3',
    ERROR_PAGE: '*',
};
